import React from 'react';
import './MangeAllOrders.css'

const ManageAllOrders = () => {
    return (
        <div className="ManageAllOrders-container">
            <h2>Manage Orders admin Page</h2>
        </div>
    );
};

export default ManageAllOrders;